export class CurrentMonthlyLimit {
    constructor(data: {
        limitCents: number | null;
        usedCents: number | null;
        remainingCents: number | null;
    }) {
        this.limit = data.limitCents !== null && data.limitCents > 0 ? data.limitCents / 100 : 0;
        this.used = data.usedCents ? data.usedCents / 100 : 0;
        this.remaining = data.remainingCents ? data.remainingCents / 100 : 0;
        this.remainingPercentage = this.limit > 0 ? (this.used / this.limit) * 100 : 0;
    }

    limit: number;
    used: number;
    remaining: number;
    remainingPercentage: number;
}

interface IApiCurrentLimits {
    daily: {
        limitCents: number | null;
        usedCents: number | null;
        remainingCents: number | null;
    } | null;
    weekly: {
        limitCents: number | null;
        usedCents: number | null;
        remainingCents: number | null;
    } | null;
    monthly: {
        limitCents: number | null;
        usedCents: number | null;
        remainingCents: number | null;
    } | null;
    transactionLimitCents: number | null;
}

export class CurrentMonthlyLimitInfoResponse {
    constructor(data: IApiCurrentLimits) {
        this.daily = data.daily ? new CurrentMonthlyLimit(data.daily) : null;
        this.weekly = data.weekly ? new CurrentMonthlyLimit(data.weekly) : null;
        this.monthly = data.monthly ? new CurrentMonthlyLimit(data.monthly) : null;
        this.transactionLimit = data.transactionLimitCents ? data.transactionLimitCents / 100 : 0;
    }

    daily?: CurrentMonthlyLimit | null;
    weekly?: CurrentMonthlyLimit | null;
    monthly?: CurrentMonthlyLimit | null;
    transactionLimit: number;
}
